import { render, staticRenderFns } from "./changeLanguage.vue?vue&type=template&id=394e3268"
import script from "./changeLanguage.vue?vue&type=script&lang=js"
export * from "./changeLanguage.vue?vue&type=script&lang=js"
import style0 from "./changeLanguage.vue?vue&type=style&index=0&id=394e3268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports